<template>
    <div class="container-fluid" style="background-color: white;">
        <!--submit-->
        <div class="row">
            <div class="col text-right">
                <button class="btn btn-default margin next" @click="goToBackWard">
                    <icon name="backward"></icon>
                    ย้อนกลับ
                </button>
                <button class="btn btn-default margin next" @click="goToForward">
                    <icon name="forward"></icon>
                    ถัดไป
                </button>
                <button class="btn btn-success margin"
                        @click="showConfirmModal">
                    <icon name="save"></icon>
                    บันทึกจบ
                </button>
                <button class="btn btn-danger margin" @click="goToEmployeeList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <!--content-->
        <div class="row">
            <div class="col-6 border border-dark" style=" min-height: 500px">
                <br/>
                <h5>รายละเอียดประกันสังคม</h5>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label for="status_pay_insurance">หักประกันสังคม</label>
                    </div>
                    <div :class="colField">
                        <input type="checkbox"
                               v-model="form.insurance.status_pay_insurance"
                               :value="1"
                               class="form-check-input"
                               id="status_pay_insurance" />
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>วิธีหัก</label>
                    </div>
                    <div :class="colField">
                        <b-form-select :options="options" v-model="form.insurance.how_insurance_pay"></b-form-select>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>วันที่สมัคร</label>
                    </div>
                    <div :class="colField">
                        <date-picker v-model="form.insurance.date"
                                :lang="lang"
                                :format="changeFormat"
                                class="w-100"
                                placeholder="วันที่สมัคร">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>เลขประกันสังคม</label>
                    </div>
                    <div :class="colField">
                       <input type="text" class="form-control"
                              placeholder="เลขประกันสังคม"
                              v-model="form.insurance.insurance_card_number" />
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>คำนำหน้าชื่อ</label>
                    </div>
                    <div :class="colField">
                        <b-form-select :options="optionPrefix" v-model="form.insurance.name_title_id"></b-form-select>
                    </div>
                </div>
            </div>
            <div class="col-6 border border-dark" style=" min-height: 500px">
                <br/>
                <h5>รหัสสถานรักษาพยาบาลที่พนง.ต้องการ</h5>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>ชื่อสถานรักษาพยาบาลปัจจุบัน</label>
                    </div>
                    <div :class="colField">
                        <input type="text" class="form-control" placeholder="โรงพยาบาลปัจจุบัน" v-model="form.insurance.hospital_name"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>ต้องการเลือก อันดับ 1</label>
                    </div>
                    <div :class="colField">
                        <input class="form-control" placeholder="โรงพยาบาล 1" v-model="form.insurance.hospital1"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>อันดับ 2</label>
                    </div>
                    <div :class="colField">
                        <input class="form-control" placeholder="โรงพยาบาล 2" v-model="form.insurance.hospital2"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="colLabel" class="text-right">
                        <label>อันดับ 3</label>
                    </div>
                    <div :class="colField">
                        <input class="form-control" placeholder="โรงพยาบาล 3" v-model="form.insurance.hospital3"/>
                    </div>
                </div>
            </div>
        </div>
<!--        <pre class="alert-success">{{form}}</pre>-->
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployeeInsurance">
            </confirm-emp-modal>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import DatePicker from 'vue2-datepicker'
    import Multiselect from "vue-multiselect";
    import moment from "moment";
    import MaskedInput from 'vue-masked-input'
    import confirmEmpModal from "../../../Utility/ConfirmEmpModal";

    import {
        canViewSuperAdmin
    } from "../../../../util/Permissions";
    export default {
        name: "employee-social-insurance",
        components :{
            DatePicker,
            Multiselect,
            MaskedInput,
            confirmEmpModal
        },
        data(){
            return{
                colLabel : 'col-4',
                colField : 'col-6',
                optionHospital:[
                    {text:"เลือกโรงพยาบาล" ,value: null},
                    {text:"A" ,value: 1},
                    {text:"B" ,value: 2},
                    {text:"C" ,value: 3}
                ],
                optionPrefix:[
                    {text:"เลือกคำนำหน้า" ,value: null},
                    {text:"นาย" ,value: 1},
                    {text:"นาง" ,value: 2},
                    {text:"นางสาว" ,value: 3}
                ],
                options:[
                    {value : null,text : 'วิธีหักประกันสังคม'},
                    {value : 1,text : 'พนักงานจ่ายเอง'},
                ],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        created(){

        },
        computed :{
            canViewSuperAdmin,
            ...mapState({
                form:state =>{
                    return state.Employee.employeeForm;
                },
                user : state=>{
                    return state.Auth.user;
                },
            })
        },
        methods: {
            showConfirmModal() {
                this.$refs.confirmEmp.show();
            },
            goToEmployeeList() {
                this.$router.push({
                    name: "employee"
                })
            },
            goToForward() {
                this.$router.push({
                    name: "employee-information-leaveDay"
                })
            },
            goToBackWard() {
                this.$router.push({
                    name: "employee-information-quarantee"
                })
            },
            saveEmployeeInsurance(value) {
                if (value) {
                    this.form.user_id = this.user.id;
                    this.$store.dispatch("Employee/saveEmployee", {
                        id: this.form.id,
                        data: this.form
                    });
                    this.goToEmployeeList();
                }
                else {
                    this.$refs.confirmEmp.hide();
                }
            }
        }
    }
</script>

<style scoped>
    body {font-family: Arial, Helvetica, sans-serif;}
    * {box-sizing: border-box;}

    .form-inline {
        display: flex;
        flex-flow: row wrap;
        align-items: left;
    }

    .form-inline label {
        margin: 5px 10px 5px 0;
    }

    .form-inline input {
        vertical-align: middle;
        margin: 5px 10px 5px 0;
        padding: 10px;
        background-color: #fff;
        border: 1px solid #ddd;
    }

    .form-inline button {
        padding: 10px 20px;
        border: 1px solid #ddd;
        color: white;
        cursor: pointer;
    }

    .form-inline button:hover {

    }

    @media (max-width: 800px) {
        .form-inline input {
            margin: 10px 0;
        }

        .form-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }
    .padding{
        padding: 20px;
    }
    .margin{
        margin: 10px;
    }
</style>
